// extracted by mini-css-extract-plugin
export default {"customClass":"customClass_src-libs-tooltip-_tooltip-wrapper_customClass_veI8_"};